<template>
  <div
    class="listComponentMainWrapper"
    ref="listComponentMainWrapper"
  >
    <div class="sectionTitleBlock">
      <span class="sectionTitle">Factures & DR ({{(listeFactures?.length ?? 0) + (listeRemboursements?.length ?? 0)}})</span>
      <div class="buttonWrapper">
        <BasicButton
          label="Déposer une facture"
          @click="redirectExterne('https://selfe-akto-sinergies-rec.inqipit.fr/entities')"
        />
        <BasicTooltip
          :label="statusDr.disabled ? statusDr.message : 'Créer une demande de remboursement'"
        >
          <BasicButton
            v-if="statusDr.visible"
            :disabled="statusDr.disabled"
            label="Nouvelle demande de remboursement"
            :span="1"
            icon-name="add"
            :deactivated="statusDr.disabled"
            :is-readonly="statusDr.disabled"
            @click="statusDr.addDemandeDR"
            style="width: 100%"
          />
        </BasicTooltip>
      </div>
    </div>
    <!-- Desktop version -->
    <div class="desktopWrapper">
      <div class="cardLayoutWrapper cardLayoutWrapper--header">
        <div class="elem elem--span-3">
          <span>Type</span>
        </div>
        <div class="elem elem--span-9">
          <span>Référence</span>
        </div>
        <div class="elem elem--span-3">
          <span>Date facturation</span>
        </div>
        <div class="elem elem--span-6">
          <span>Emetteur</span>
        </div>
        <div class="elem elem--span-3">
          <span>Statut</span>
        </div>
        <div class="elem elem--span-3" style="justify-content: end;">
          <span>Montant (HT)</span>
        </div>
        <div class="elem elem--span-3" style="justify-content: end;">
          <span>Montant (TTC)</span>
        </div>
        <div class="elem elem--span-3" style="justify-content: center;">
          <span>Lien facture / DR</span>
        </div>
        <div class="elem elem--span-3" style="justify-content: center;">
          <span>Lien proforma</span>
        </div>
      </div>

      <div
        v-for="(facture, index) in listeFactures"
        class="listCardDesktopWrapper"
        :key="index"
      >
        <div class="cardLayoutWrapper">
          <div class="elem elem--span-3">
            <BasicText>{{ TypeFacturationLibelle[facture.type] }}</BasicText>
          </div>
          <div class="elem elem--span-9">
            <BasicText>{{ facture.reference}}</BasicText>
          </div>
          <div class="elem elem--span-3">
            <BasicText>{{ dateFormatter(facture.dateEmission) }}</BasicText>
          </div>
          <div class="elem elem--span-6">
            <BasicText>{{ facture.etablissementEmetteur?.denomination }}</BasicText>
          </div>
          <div class="elem elem--span-3">
            <BasicBadge
              :type="StatutFactureBadgeType[facture.statut]"
              size="medium"
              :deletable="false"
              :label="StatutFactureLibelle[facture.statut]"
            />
          </div>
          <div class="elem elem--span-3 elem--right">
            <BasicText>{{ formatNumber(facture.montantHt, { decimal: 2, separateur: true }) + ' €' }}</BasicText>
          </div>
          <div class="elem elem--span-3 elem--right">
            <BasicText>{{ formatNumber(facture.montantTTC, { decimal: 2, separateur: true }) + ' €' }}</BasicText>
          </div>
          <div class="elem elem--span-3" style="justify-content: center;">
            <BasicButton
              iconRight
              size="small"
              iconName="eye"
              @click="() => displayFacture(facture.code)"
            />
          </div>
          <div class="elem elem--span-3" style="justify-content: center;"></div>
        </div>
      </div>
      <div
        v-for="(remboursement, index) in listeRemboursements"
        class="listCardDesktopWrapper"
        :key="index"
      >
        <div class="cardLayoutWrapper">
          <div class="elem elem--span-3">
            <BasicText>{{ TypeFacturationLibelle[remboursement.type] }}</BasicText>
          </div>
          <div class="elem elem--span-9">
            <BasicText>{{ remboursement.reference + (remboursement.referenceProforma ? ' / ' + remboursement.referenceProforma : '') }}</BasicText>
          </div>
          <div class="elem elem--span-3">
            <BasicText>{{ dateFormatter(remboursement.dateEmission) }}</BasicText>
          </div>
          <div class="elem elem--span-6">
            <BasicText>{{ remboursement.etablissementEmetteur?.denomination }}</BasicText>
          </div>
          <div class="elem elem--span-3">
            <BasicBadge
              :type="StatutBadgeType[remboursement.statut]"
              size="medium"
              :deletable="false"
              :label="StatutLibelle[remboursement.statut]"
            />
          </div>
          <div class="elem elem--span-3 elem--right">
            <BasicText>{{ formatNumber(remboursement.montantHt, { decimal: 2, separateur: true }) + ' €' }}</BasicText>
          </div>
          <div class="elem elem--span-3 elem--right">
            <BasicText>{{ formatNumber(remboursement.montantTTC, { decimal: 2, separateur: true }) + ' €' }}</BasicText>
          </div>
          <div class="elem elem--span-3" style="justify-content: center;">
            <BasicButton
              iconRight
              size="small"
              iconName="eye"
              @click="() => navigateToDR(remboursement as any)"
            />
          </div>
          <div class="elem elem--span-3" style="justify-content: center;">
            <BasicButton
              v-if="remboursement.codeProforma"
              iconRight
              size="small"
              iconName="eye"
              @click="displayFacture(remboursement.codeProforma)"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile version -->
    <div class="mobileWrapper">
      <div
        class="mobileCardWrapper"
        v-for="(facture, index) in listeFactures"
        :key="index"
      >
        <div class="header">
          <div class="headerContent">
            <span class="headerTitle">{{ TypeFacturationLibelle[facture.type] }}</span>
            <BasicBadge
              :type="StatutFactureBadgeType[facture.statut]"
              size="medium"
              :deletable="false"
              :label="StatutFactureLibelle[facture.statut]"
            />
            <span class="headerSubtitle"><span>Référence :</span> {{ facture.reference }}</span>
            <span class="headerSubtitle"><span>Date facturation :</span> {{ dateFormatter(facture.dateEmission) }}</span>
            <span class="headerSubtitle"><span>Emetteur :</span> {{ facture.etablissementEmetteur?.denomination }}</span>
            <span class="headerSubtitle"><span>Montant HT :</span> {{ formatNumber(facture.montantHt, { decimal: 2, separateur: true }) + ' €' }}</span>
            <span class="headerSubtitle"><span>Montant TTC :</span> {{ formatNumber(facture.montantTTC, { decimal: 2, separateur: true }) + ' €' }}</span>
          </div>
        </div>
        <div class="content">
          <div class="contentElement">
            <BasicButton
              label="Voir la facture / DR"
              iconRight
              iconName="eye"
              @click="() => displayFacture(facture.code)"
            />
          </div>
        </div>
      </div>
      <div
        class="mobileCardWrapper"
        v-for="(remboursement, index) in listeRemboursements"
        :key="index"
      >
        <div class="header">
          <div class="headerContent">
            <span class="headerTitle">{{ TypeFacturationLibelle[remboursement.type] }}</span>
            <BasicBadge
              :type="StatutBadgeType[remboursement.statut]"
              size="medium"
              :deletable="false"
              :label="StatutLibelle[remboursement.statut]"
            />
            <span class="headerSubtitle"><span>Référence :</span> {{ remboursement.reference + (remboursement.referenceProforma ? ' / ' + remboursement.referenceProforma : '') }}</span>
            <span class="headerSubtitle"><span>Date facturation :</span> {{ dateFormatter(remboursement.dateEmission) }}</span>
            <span class="headerSubtitle"><span>Emetteur :</span> {{ remboursement.etablissementEmetteur?.denomination }}</span>
            <span class="headerSubtitle"><span>Montant HT :</span> {{ formatNumber(remboursement.montantHt, { decimal: 2, separateur: true }) + ' €' }}</span>
            <span class="headerSubtitle"><span>Montant TTC :</span> {{ formatNumber(remboursement.montantTTC, { decimal: 2, separateur: true }) + ' €' }}</span>
          </div>
        </div>
        <div class="content">
          <div class="contentElement">
            <BasicButton
              label="Voir la facture / DR"
              iconRight
              iconName="eye"
              @click="() => navigateToDR(remboursement as any)"
            />
          </div>
          <div
            class="contentElement"
            v-if="remboursement.codeProforma"
          >
            <BasicButton
              label="Voir la proforma"
              iconRight
              iconName="eye"
              @click="displayFacture(remboursement.codeProforma)"
            />
          </div>
        </div>
      </div>
    </div>
    <span
        v-if="!listeFactures?.length && !listeRemboursements?.length"
        class="emptyListPlaceholder"
      >
        Aucun élément
      </span>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import type { DossierDTO } from '@/features/api/extranet/dto/Dossier/Synthese'
  import type { FactureDTO } from '@/features/api/extranet/dto/Dossier/Synthese';
  import type { RemboursementDTO } from '@/features/api/extranet/dto/Dossier/Synthese';
  import { dateFormatter, formatNumber } from '@/features/shared/tools';
  import { StatutBadgeType, StatutLibelle } from '@/features/domaine/types/opco/Remboursements/Statut';
  import { StatutFactureLibelle, StatutFactureBadgeType } from '@/features/api/extranet/dto/Facture/StatutFactureDTO'
  import { useRechercheDRActions } from '@/features/interface/recherches/dr/useRechercheDRActions'
  import { useRechercheFactureActions } from '@/features/interface/recherches/facture/useRechercheFactureActions';
  import { TypeFacturationLibelle } from '@/features/api/extranet/dto/Dossier/Synthese'
  import { redirectExterne } from '@/features/shared/tools/url'
  import { useRechercheDossierActions } from '@/features/interface/recherches/dossier/useRechercheDossierActions';

  const props = defineProps<{
    dossier: DossierDTO | undefined
    listeFactures: FactureDTO[] | undefined
    listeRemboursements: RemboursementDTO[] | undefined
  }>()

  const { navigateToDR } = useRechercheDRActions('demande')
  const { displayFacture } = useRechercheFactureActions()
  const { getStatusDR } = useRechercheDossierActions()

  const statusDr = computed(() => getStatusDR(props.dossier!))
</script>

<style lang="less" scoped>
@import '../../../recherches/index.less';
@import '../../../recherches/demande/components/DemandeCardMobile.less';

.listComponentMainWrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 16px;
  background: #ffffff;
  padding: 24px;
}

.sectionTitleBlock {
  display: flex;
  align-items: center;

  .buttonWrapper {
    margin-top: unset;
  }
}

.sectionTitle {
  color: #0c282e;
  font-size: 18px;
  font-weight: 600;
}

@container (max-width: @breakpoint-tablet) {
  .sectionTitleBlock {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    .buttonWrapper {
      flex-direction: column;
      width: 100%;
    }
  }
}
</style>
